export default {
  domains: {
    kyc: {
      components: {},
    },
  },
};
